import React, { useEffect, useState,useMemo } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import "./PlayerHistory.css";

import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend
} from "recharts";

const PlayerHistory = () => {

  const { email } = useParams();

  const [history, setHistory] =
  useState({});

  const [reactionView, setReactionView] =
    useState("best");

  useEffect(() => {
    loadHistory();
  }, [email]);

  const loadHistory = async () => {

    try {

      const res = await axios.get(
        `/api/admin/player-history/${email}`
      );

      setHistory(res.data);

    } catch (err) {

      console.error(err);

    }

  };

  

 const formatDate = (date) =>
  new Date(date).toLocaleDateString(
    "en-IN",
    {
      day: "2-digit",
      month: "short"
    }
  );


  /* =========================
     SUMMARY CARDS
  ========================= */

const getBestResult = (item) => {

  if (!item.results?.length) {
    return null;
  }

  return Math.min(
    ...item.results.map(
      r => Number(r.result)
    )
  );

};

const getMaxResult = (item) => {

  if (!item.results?.length) {
    return null;
  }

  return Math.max(
    ...item.results.map(
      r => Number(r.result)
    )
  );

};
const validReaction =
  history.reaction?.filter(
    x =>
      x.results?.length &&
      (x.wrongClicks || 0) === 0
  ) || [];

const reactionBest =
  validReaction.length
    ? Math.round(
        Math.min(
          ...validReaction.map(
            getBestResult
          )
        ) * 1000
      )
    : "-";

const reactionAvg =
  history.reaction?.length
    ? Math.round(
        history.reaction.reduce(
          (sum, item) =>
            sum +
            (item.averageReaction || 0),
          0
        ) /
          history.reaction.length *
          1000
      )
    : "-";

const validComplex =
  history.complexReaction?.filter(
    x =>
      x.results?.length &&
      (x.wrongClicks || 0) === 0
  ) || [];

const complexBest =
  validComplex.length
    ? Math.round(
        Math.min(
          ...validComplex.map(
            getBestResult
          )
        ) * 1000
      )
    : "-";

  const searchSpanBest =
    history.searchSpan?.length
      ? Math.max(
          ...history.searchSpan.map(
            x =>
              x.finalNumber || 0
          )
        )
      : "-";

  const workingMemoryBest =
    history.workingMemory?.length
      ? Math.max(
          ...history.workingMemory.map(
            x =>
              x.level || 0
          )
        )
      : "-";

  const shortMemoryBest =
    history.shortTermMemory?.length
      ? Math.max(
          ...history.shortTermMemory.map(
            x =>
              x.level || 0
          )
        )
      : "-";

  const anticipationBest =
    history.anticipation?.length
      ? Math.max(
          ...history.anticipation.map(
            x =>
              x.score || 0
          )
        )
      : "-";

  const acuityOrder = {
  "6/60": 1,
  "6/36": 2,
  "6/24": 3,
  "6/18": 4,
  "6/12": 5,
  "6/9": 6,
  "6/6": 7,
  "6/5": 8,
  "6/4.5": 9,
  "6/4": 10,
  "6/3.5": 11,
  "6/3": 12,
  "6/2.5": 13
};

const visualAcuityBest =
  history.visualAcuity?.length

    ? history.visualAcuity
        .filter(
          x =>
            acuityOrder[
              x.bothEyes
            ]
        )
        .sort(
          (a, b) =>
            acuityOrder[
              b.bothEyes
            ] -
            acuityOrder[
              a.bothEyes
            ]
        )[0]?.bothEyes

    : "-";
  const contrastBest =
  history.contrastSensitivity?.length
    ? Math.max(
        ...history.contrastSensitivity.map(
          x =>
            x.finalContrast || 0
        )
      )
    : "-";

  let graphData = [];

 
  let workingMemoryGraph = [];

  let shortMemoryGraph = [];

  let searchSpanGraph = [];

  let anticipationGraph = [];

  

  let contrastGraph = [];

  let visualAcuityGraph = [];
 
  
const reactionSystemData =
  useMemo(() => {

    if (!history) return [];

    const grouped = {};

    /* REACTION */

    (history.reaction || [])
      .forEach(item => {

        if (
          reactionView === "best" &&
          (item.wrongClicks || 0) > 0
        ) {
          return;
        }

        const key =
          formatDate(
            item.createdAt
          );

        if (!grouped[key]) {

          grouped[key] = {
            date: key,
            fullDate:
              item.createdAt,
            reaction: null,
            complex: null
          };

        }

        const rawValue =

          reactionView === "best"

            ? getBestResult(
                item
              )

            : getMaxResult(
                item
              );

        const value =

          rawValue &&
          rawValue > 0

            ? Math.round(
                rawValue * 1000
              )

            : null;

        if (
          reactionView === "best" &&
          (
            value === null ||
            value < 100
          )
        ) {
          return;
        }

        if (
          value !== null &&
          (
            grouped[key]
              .reaction === null ||

            (
              reactionView === "best"

                ? value <
                  grouped[key]
                    .reaction

                : value >
                  grouped[key]
                    .reaction
            )
          )
        ) {

          grouped[key]
            .reaction =
            value;

        }

      });

    /* COMPLEX */

    (history.complexReaction || [])
      .forEach(item => {

        if (
          reactionView === "best" &&
          (item.wrongClicks || 0) > 0
        ) {
          return;
        }

        const key =
          formatDate(
            item.createdAt
          );

        if (!grouped[key]) {

          grouped[key] = {
            date: key,
            fullDate:
              item.createdAt,
            reaction: null,
            complex: null
          };

        }

        const rawValue =

          reactionView === "best"

            ? getBestResult(
                item
              )

            : getMaxResult(
                item
              );

        const value =

          rawValue &&
          rawValue > 0

            ? Math.round(
                rawValue * 1000
              )

            : null;

        if (
          reactionView === "best" &&
          (
            value === null ||
            value < 100
          )
        ) {
          return;
        }

        if (
          value !== null &&
          (
            grouped[key]
              .complex === null ||

            (
              reactionView === "best"

                ? value <
                  grouped[key]
                    .complex

                : value >
                  grouped[key]
                    .complex
            )
          )
        ) {

          grouped[key]
            .complex =
            value;

        }

      });

    return Object
      .values(grouped)
      .filter(
        item =>
          item.reaction !== null ||
          item.complex !== null
      )
      .sort(
        (a, b) =>
          new Date(
            a.fullDate
          ) -
          new Date(
            b.fullDate
          )
      );

  }, [
    history,
    reactionView
  ]);

const reactionTitle =
  `Reaction System (${
    reactionView === "best"
      ? "Best"
      : "Max"
  })`;
    /* =========================
     WORKING MEMORY GRAPH
  ========================= */

  workingMemoryGraph =
  Object.values(

    (history.workingMemory || [])
      .reduce(
        (acc, item) => {

          const date =
            formatDate(
              item.createdAt
            );

          if (
            !acc[date] ||
            item.level >
              acc[date].score
          ) {

            acc[date] = {

              date,

              fullDate:
                item.createdAt,

              score:
                item.level || 0

            };

          }

          return acc;

        },
        {}
      )

  )
  .sort(
    (a, b) =>
      new Date(
        a.fullDate
      ) -
      new Date(
        b.fullDate
      )
  );


  /* =========================
     SHORT MEMORY GRAPH
  ========================= */

  shortMemoryGraph =
  Object.values(

    (history.shortTermMemory || [])
      .reduce(
        (acc, item) => {

          const date =
            formatDate(
              item.createdAt
            );

          if (
            !acc[date] ||
            item.level >
              acc[date].score
          ) {

            acc[date] = {

              date,

              fullDate:
                item.createdAt,

              score:
                item.level || 0

            };

          }

          return acc;

        },
        {}
      )

  )
  .sort(
    (a, b) =>
      new Date(
        a.fullDate
      ) -
      new Date(
        b.fullDate
      )
  );
  searchSpanGraph =
  Object.values(

    (history.searchSpan || [])
      .reduce(
        (acc, item) => {

          if (
            !item.finalNumber ||
            item.finalNumber <= 0
          ) {
            return acc;
          }

          const date =
            formatDate(
              item.createdAt
            );

          if (
            !acc[date] ||
            item.finalNumber >
              acc[date].score
          ) {

            acc[date] = {

              date,

              fullDate:
                item.createdAt,

              score:
                item.finalNumber

            };

          }

          return acc;

        },
        {}
      )

  )
  .sort(
    (a, b) =>
      new Date(
        a.fullDate
      ) -
      new Date(
        b.fullDate
      )
  );
  /* =========================
     GRAPH BEST VALUES
  ========================= */

  const workingMemoryBestValue =

    history.workingMemory?.length

      ? Math.max(
          ...history.workingMemory.map(
            x =>
              x.level || 0
          )
        )

      : 0;


  const shortMemoryBestValue =

    history.shortTermMemory?.length

      ? Math.max(
          ...history.shortTermMemory.map(
            x =>
              x.level || 0
          )
        )

      : 0;


  const searchSpanBestValue =

    history.searchSpan?.length

      ? Math.max(
          ...history.searchSpan.map(
            x =>
              x.finalNumber || 0
          )
        )

      : 0;
    /* =========================
     ANTICIPATION GRAPH
  ========================= */

  anticipationGraph =
  Object.values(

    (history.anticipation || [])
      .reduce(
        (acc, item) => {

          const date =
            formatDate(
              item.createdAt
            );

          if (
            !acc[date] ||
            item.score >
              acc[date].score
          ) {

            acc[date] = {

              date,

              fullDate:
                item.createdAt,

              score:
                item.score || 0

            };

          }

          return acc;

        },
        {}
      )

  )
  .sort(
    (a, b) =>
      new Date(
        a.fullDate
      ) -
      new Date(
        b.fullDate
      )
  );

  /* =========================
     CONTRAST GRAPH
  ========================= */

  contrastGraph =
  Object.values(

    (history.contrastSensitivity || [])
      .reduce(
        (acc, item) => {

          const date =
            formatDate(
              item.createdAt
            );

          if (
            !acc[date] ||
            item.finalContrast >
              acc[date].score
          ) {

            acc[date] = {

              date,

              fullDate:
                item.createdAt,

              score:
                item.finalContrast || 0

            };

          }

          return acc;

        },
        {}
      )

  )
  .sort(
    (a, b) =>
      new Date(
        a.fullDate
      ) -
      new Date(
        b.fullDate
      )
  );


  /* =========================
     VISUAL ACUITY GRAPH
  ========================= */

  const acuityMap = {

    "6/60": 1,
    "6/36": 2,
    "6/24": 3,
    "6/18": 4,
    "6/12": 5,
    "6/9": 6,
    "6/6": 7,
    "6/5": 8,
    "6/4.5": 9,
    "6/4": 10,
    "6/3.5": 11,
    "6/3": 12,
    "6/2.5": 13

  };
visualAcuityGraph =
  Object.values(

    (history.visualAcuity || [])
      .reduce(
        (acc, item) => {

          const score =
            acuityMap[
              item.bothEyes
            ];

          if (
            !score ||
            item.bothEyes === "None" ||
            item.bothEyes === "nan"
          ) {
            return acc;
          }

          const date =
            formatDate(
              item.createdAt
            );

          if (
            !acc[date] ||
            score >
              acc[date].score
          ) {

            acc[date] = {

              date,

              fullDate:
                item.createdAt,

              score

            };

          }

          return acc;

        },
        {}
      )

  )
  .sort(
    (a, b) =>
      new Date(
        a.fullDate
      ) -
      new Date(
        b.fullDate
      )
  );

  /* =========================
     BEST VALUES
  ========================= */

  const anticipationBestValue =

    history.anticipation?.length

      ? Math.max(
          ...history.anticipation.map(
            x =>
              x.score || 0
          )
        )

      : 0;


 


  const contrastBestValue =

    history.contrastSensitivity?.length

      ? Math.max(
          ...history.contrastSensitivity.map(
            x =>
              x.finalContrast || 0
          )
        )

      : 0;


  const visualAcuityBestValue =

    history.visualAcuity?.length

      ? Math.max(
          ...history.visualAcuity.map(
            x =>
              acuityMap[
                x.bothEyes
              ] || 0
          )
        )

      : 0;
  return (

  <div className="history-page">

    <h1>
      Player Performance Analysis
    </h1>

    {/* SUMMARY CARDS */}

    <div className="summary-cards">

      <div className="summary-card">
        <h4>Reaction Best</h4>
        <h2>{reactionBest} ms</h2>
      </div>

     

      <div className="summary-card">
        <h4>Complex Best</h4>
        <h2>{complexBest} ms</h2>
      </div>

      <div className="summary-card">
        <h4>Search Span</h4>
        <h2>{searchSpanBest}</h2>
      </div>

      <div className="summary-card">
        <h4>Working Memory</h4>
        <h2>{workingMemoryBest}</h2>
      </div>

      <div className="summary-card">
        <h4>Short-Term Visual Memory</h4>
        <h2>{shortMemoryBest}</h2>
      </div>

      <div className="summary-card">
        <h4>Anticipation</h4>
        <h2>{anticipationBest}</h2>
      </div>

      <div className="summary-card">
        <h4>Visual Acuity</h4>
        <h2>{visualAcuityBest}</h2>
      </div>
      <div className="summary-card">
        <h4>Contrast</h4>
        <h2>{contrastBest}</h2>
      </div>

    </div>

    {/* REACTION SYSTEM */}

    <div className="graph-card">

      <div className="reaction-header">

        <h2>
          {reactionTitle}
        </h2>

        <select
          className="reaction-select"
          value={reactionView}
          onChange={(e) =>
            setReactionView(
              e.target.value
            )
          }
        >
          <option value="best">
            Best
          </option>

          <option value="average">
            Average
          </option>
        </select>

      </div>

      <ResponsiveContainer
        width="100%"
        height={400}
      >

        <LineChart
  data={reactionSystemData}
>
  <CartesianGrid
    strokeDasharray="3 3"
  />

  <XAxis
  dataKey="date"
  interval={Math.ceil(
    reactionSystemData.length / 8
  )}
  tick={{ fontSize: 12 }}
  minTickGap={30}
/>

  <YAxis />

  <Tooltip
    formatter={(value, name) => [
      `${value} ms`,
      name
    ]}
  />

  <Legend />

  <Line
    type="monotone"
    dataKey="reaction"
    name="Reaction"
    stroke="#2563eb"
    strokeWidth={3}
    connectNulls
    dot={{ r: 4 }}
    activeDot={{ r: 6 }}
  />

  <Line
    type="monotone"
    dataKey="complex"
    name="Complex"
    stroke="#ef4444"
    strokeWidth={3}
    connectNulls
    dot={{ r: 4 }}
    activeDot={{ r: 6 }}
  />

</LineChart>
      </ResponsiveContainer>

    </div>

    {/* OTHER TESTS */}

    <div className="graph-grid">

      {/* WORKING MEMORY */}

      <div className="graph-card">

        <h2>
          Working Memory
        </h2>

        <ResponsiveContainer
          width="100%"
          height={300}
        >

          <LineChart
            data={workingMemoryGraph}
          >

            <CartesianGrid
              strokeDasharray="3 3"
            />

            <XAxis
              dataKey="date"
            />

            <YAxis
              domain={[
                dataMin =>
                  Math.max(
                    1,
                    dataMin - 1
                  ),
                dataMax =>
                  dataMax + 1
              ]}
              allowDecimals={false}
            />

            <Tooltip />

            <Line
              type="monotone"
              dataKey="score"
              stroke="#2563eb"
              strokeWidth={3}
            />

          </LineChart>

        </ResponsiveContainer>

      </div>

      {/* SHORT MEMORY */}

      <div className="graph-card">

        <h2>
          Short-Term Visual Memory
        </h2>

        <ResponsiveContainer
          width="100%"
          height={300}
        >

          <LineChart
            data={shortMemoryGraph}
          >

            <CartesianGrid
              strokeDasharray="3 3"
            />

            <XAxis
              dataKey="date"
            />

            <YAxis
                domain={[
                  dataMin =>
                    Math.max(
                      0,
                      dataMin - 1
                    ),
                  dataMax =>
                    dataMax + 1
                ]}
                allowDecimals={false}
              />

            <Tooltip />

            <Line
              type="monotone"
              dataKey="score"
              stroke="#2563eb"
              strokeWidth={3}
            />

          </LineChart>

        </ResponsiveContainer>

      </div>

      {/* SEARCH SPAN */}

      <div className="graph-card">

        <h2>
          Search Span
        </h2>

        <ResponsiveContainer
          width="100%"
          height={300}
        >

          <LineChart
            data={searchSpanGraph}
          >

            <CartesianGrid
              strokeDasharray="3 3"
            />

            <XAxis
              dataKey="date"
            />

            <YAxis
                allowDecimals={false}
                domain={[
                  dataMin =>
                    Math.max(
                      0,
                      dataMin - 1
                    ),
                  dataMax =>
                    dataMax + 1
                ]}
              />

            <Tooltip />

            <Line
              type="monotone"
              dataKey="score"
              stroke="#2563eb"
              strokeWidth={3}
            />

          </LineChart>

        </ResponsiveContainer>

      </div>

      {/* ANTICIPATION */}

      <div className="graph-card">

        <h2>
          Anticipation
        </h2>

        <ResponsiveContainer
          width="100%"
          height={300}
        >

          <LineChart
            data={anticipationGraph}
          >

            <CartesianGrid
              strokeDasharray="3 3"
            />

            <XAxis
              dataKey="date"
            />

            <YAxis />

            <Tooltip />

            <Line
              type="monotone"
              dataKey="score"
              stroke="#2563eb"
              strokeWidth={3}
            />

          </LineChart>

        </ResponsiveContainer>

       </div>

      {/* CONTRAST */}

      <div className="graph-card">

        <h2>
          Contrast Sensitivity
        </h2>

        <ResponsiveContainer
          width="100%"
          height={300}
        >

          <LineChart
            data={contrastGraph}
          >

            <CartesianGrid
              strokeDasharray="3 3"
            />

            <XAxis dataKey="date" />

            <YAxis />

            <Tooltip />

            <Line
              type="monotone"
              dataKey="score"
              stroke="#2563eb"
              strokeWidth={3}
            />

          </LineChart>

        </ResponsiveContainer>

      </div>
      {/* VISUAL ACUITY */}

<div className="graph-card">

  <h2>
    Visual Acuity
  </h2>

  <ResponsiveContainer
    width="100%"
    height={300}
  >

    <LineChart
      data={visualAcuityGraph}
    >

      <CartesianGrid
        strokeDasharray="3 3"
      />

      <XAxis
        dataKey="date"
      />

      <YAxis
        ticks={[
          1,2,3,4,5,6,7,
          8,9,10,11,12,13
        ]}
        tickFormatter={(value) => {

          const labels = {
            1:"6/60",
            2:"6/36",
            3:"6/24",
            4:"6/18",
            5:"6/12",
            6:"6/9",
            7:"6/6",
            8:"6/5",
            9:"6/4.5",
            10:"6/4",
            11:"6/3.5",
            12:"6/3",
            13:"6/2.5"
          };

          return labels[value];

        }}
      />

      <Tooltip />

      <Line
        type="monotone"
        dataKey="score"
        stroke="#2563eb"
        strokeWidth={3}
      />

    </LineChart>

  </ResponsiveContainer>

</div>

    </div>

    

  </div>

);

};

export default PlayerHistory;